<template>
  <v-list nav>
    <v-list-item-group v-model="selectedItem" active-class="color">
      <template v-for="(item, i) in filteredLinks">
        <!-- if a menu item with no to nor href -->
        <v-list-item
            :key="i"
            v-if="!(item.to || item.href)"
            class="ItemsGroupTitle"
            disabled>
          <v-list-item-title class="ItemsGroupTitleText">{{ $t(item.text) }}</v-list-item-title>
        </v-list-item>

        <!-- else if it has to -->
        <v-list-item
            v-if="item.to"
            :key="i"
            :to="item.to"
            @click="handleClickItem(i)"
            class="MenuItem">
          <v-list-item-title class="MenuItemText">{{ $t(item.text) }}</v-list-item-title>
        </v-list-item>

        <!-- else if it has href -->
        <v-list-item
            v-if="item.href"
            :key="i"
            class="MenuItem">
          <v-list-item-title class="MenuItemText"
                             style="opacity: 0.4">{{ $t(item.text) }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { filterLinks } from '../../utils/NavigationMenu';

export default {
  name: 'NavigationList',

  data: () => {
    return {
      filterLinks,
    };
  },

  methods: {
    handleClickItem(selectedIndex) {
      const drawerStatus = {
        isOpen: this.$vuetify.breakpoint.xs
            ? false
            : this.$store.state.uiStatus.drawerStatus.isOpen,
        selectedIndex,
      };
      this.$store.commit('setDrawerStatus', drawerStatus);
    },
  },

  computed: {
    filteredLinks() {
      if (!this.$store.state.user.user) {
        return [];
      }

      return this.filterLinks(this.$store.state.user.user.roles);
    },

    selectedItem: {
      get: function () {
        return this.$store.state.uiStatus.drawerStatus.selectedIndex;
      },
      set: function (selectedIndex) {
        const drawerStatus = {
          selectedIndex,
        };

        this.$store.commit('setDrawerStatus', drawerStatus);
      },
    },
  },
};
</script>

<style scoped>
.v-list-item-group >>> .ItemsGroupTitle {
  min-height: auto;
  padding-top: 5px;
}

.v-list-item-group >>> .ItemsGroupTitleText {
  color: var(--v-primary-base);
  font-size: 1em;
  font-weight: 600;
}

.v-list-item-group >>> .MenuItem {
  min-height: auto;
  padding-top: 8px;
  padding-left: 1.5em;
  padding-bottom: 8px;
}

.v-list-item-group >>> .MenuItemText {
  font-size: 1em;
}
</style>
